import graphql__7a749c00f1e06ed47ded from "./__generated__/Breadcrumbs_page.graphql.js";import { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { useRoutesContext } from "../Routes/RoutesContext";
import { useFormatMessage } from "../Intl/Context";
import { intlMessages as headerIntlMessages } from "../Header/Header";
import Icon from "../Utils/Icon";
import ButtonLink from "../Buttons/ButtonLink";

const Breadcrumbs = props => {
  const page = useFragment(Breadcrumbs_page, props.page);
  const { ancestors } = page;
  const { onlyShowArrow } = props;
  const { pathFor } = useRoutesContext();
  const homePath = pathFor("home");
  const t = useFormatMessage();
  const homeLabel = t(headerIntlMessages.home);
  const showHomeIcon = homePath && !onlyShowArrow;

  const displayedAncestors = useMemo(
    () => (onlyShowArrow ? ancestors.slice(0, 1) : ancestors),
    [ancestors, onlyShowArrow]
  );

  if (!ancestors?.length) return null;

  // Breadcrumbs are rendered on a white title bar.
  // Use the on-white helper so low-contrast primary colors fallback safely.
  const className = classNames("text-primary-on-white", props.className);
  const breadcrumbLinkClasses = classNames(
    "breadcrumb-link",
    "breadcrumb-link-with-arrow",
    "text-primary-on-white",
    "text-small",
    "d-flex",
    "align-items-center"
  );

  return (
    <div className={className}>
      {showHomeIcon && (
        <ButtonLink
          className={breadcrumbLinkClasses}
          href={homePath}
          aria-label={homeLabel}
        >
          <i className="fas fa-home breadcrumb-home-icon" aria-hidden="true" />
        </ButtonLink>
      )}

      {displayedAncestors.map((ancestorPage, index) => {
        return (
          <ButtonLink
            key={ancestorPage.id}
            className={breadcrumbLinkClasses}
            href={ancestorPage.resourcePath}
            aria-label={onlyShowArrow ? ancestorPage.title : null}
          >
            {index === 0 && !showHomeIcon && (
              <Icon className="icon-arrow-left margin-right-xxs" />
            )}
            {!onlyShowArrow && (
              <span className="breadcrumb-link-text">{ancestorPage.title}</span>
            )}
          </ButtonLink>
        );
      })}
    </div>
  );
};

const Breadcrumbs_page = graphql__7a749c00f1e06ed47ded;

export default Breadcrumbs;
